import React from "react";
import { Organization } from "../../model/OrganizationModel";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { AddLastUrlPathLocalStorage, AddOrganizationLocalStorage } from "../../pages/PublicLayout/RedirectManager";
import { KeydriveOrganizationAvatar } from "../KeydriveComponents/Avatar/KeydriveOrganizationAvatar";
import { KeyDriveCaption } from "../KeydriveComponents/Fonts/Captions/KeyDriveCaption";
import { KeyDriveBodyMin } from "../KeydriveComponents/Fonts/Body/KeyDriveBodyMin";

interface IOrganizationComponentCard {
    organizationSelected: Organization;
    isAdminPage?: boolean;
    org: Organization;
    fetchOrganization: (internalName: string) => Promise<void>;
    ref?: React.Ref<HTMLLIElement>;
}


export const OrganizationComponentCard: React.ForwardRefExoticComponent<IOrganizationComponentCard> =
    React.forwardRef(({ organizationSelected, org, isAdminPage, fetchOrganization }, ref: React.Ref<HTMLLIElement>) => {

        const navigate = useNavigate();
        const { t } = useTranslation();

        return (
            <li ref={ref}>
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    gap="12px"
                    marginBottom="12px"
                    border={`${
                        organizationSelected != undefined
                            ? organizationSelected.internalName == org.internalName
                                ? "1px solid #22638D"
                                : "1px solid #EAEAEA"
                            : "1px solid #EAEAEA"
                    }`}
                    borderRadius="4px"
                    padding="12px"
                    height="56px"
                    marginTop="20px"
                    onClick={(e) => {
                        if (isAdminPage) {
                            e.stopPropagation();
                            fetchOrganization(org.internalName!);
                        } else {
                            AddOrganizationLocalStorage(org.internalName!);
                            AddLastUrlPathLocalStorage(window.location.pathname);
                            navigate(`/${org.internalName!}`);
                        }
                    }}
                >
                    <Box
                        display="flex"
                        alignItems="center"
                        gap="12px"
                    >
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            gap="12px"
                        >
                            <KeydriveOrganizationAvatar
                                size="small"
                            />
                        </Box>
                        <Box>
                            <KeyDriveCaption
                                text={t("AdminConsole.Organization")}
                                color="#575757"
                                needBold={false}
                                needEllipses={false}
                            />
                            <KeyDriveBodyMin
                                needBold={false}
                                needEllipses={false}
                                text={org.name!}
                                color="#2D2D2D"
                            />
                        </Box>
                    </Box>
                </Box>
            </li>
    );
});